import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class ApprovedDocumentsActions extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {

        };

    }

    updateDocumentDossierState = (state)=>{
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages._estas_seguro_de_modificar_el_estado_de_este_documento'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText:  lang.get('messages.continuar'),
            cancelButtonText:  lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                let msg;
                if(state == 2){
                    msg = lang.get('messages.se_ha_suspendido_la_recurrencia_del_documento');
                }
                if(state == 1){
                    msg = lang.get('messages.se_ha_reactivado_la_recurrencia_del_documento');
                }
                axios.post('/api/documents/'+this.props.document.id+'/update/'+this.props.person_provider_id,{
                    state
                }).then(res=>{
                    swal.fire({
                        text: msg,
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText:lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        location.reload()
                    });
                })
            }
        });
    }
    expireDocument = ()=>{
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_caducar_este_documento_y_solicitarlo_nuevamente'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText:  lang.get('messages.continuar'),
            cancelButtonText:  lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post('/api/documents/'+this.props.document.id+'/expire/'+this.props.person_provider_id,{
                    isInternal:this.props.isInternal
                }).then(res=>{
                    swal.fire({
                        text: lang.get('messages.el_documento_ha_sido_enviado_al_historial'),
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText:lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        location.reload()
                    });
                })
            }
        });
    }
    async componentDidMount() {

    }

    render() {
        const { lang } = this.context;
        const canViewDocument = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('view_document');
        return (
            <div className="d-flex justify-content-end">
                <div className="dropdown dropdown-inline">
                    <a href="#" class="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {lang.get('messages.acciones')}
                        &nbsp;&nbsp;
                        <i class="flaticon2-down icon-sm"></i>
                    </a>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg"  >
                        <ul className="navi navi-hover">
                            {canViewDocument && (
                            <li className="navi-item">

                                <a href={"/document_dossier/" + this.props.person_provider_id +"/show_file/" + this.props.document.id} class="navi-link py-4">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon2-file-1 text-primary icon-md"></span>
                                    </span>
                                    <span className="navi-text text-secondary">{lang.get('messages.ver_documento')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            )}
                            {this.props.frequency === 'yearly' && (
                            <li className="navi-item">
                                <a onClick={  () => this.expireDocument() } class="navi-link py-4">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon2-cross text-primary icon-md"></span>
                                    </span>
                                    <span className="navi-text text-secondary"> 
                                        {lang.get('messages.caducar_y_volver_a_solicitar_documento')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            )}
                            {(
                            this.props.permissions?.dossiers_actions?.includes('all') ||
                            this.props.permissions?.dossiers_actions?.includes('stop_recurrence')
                            ) && this.props.frequency === 'yearly' && (
                            <li className="navi-item">
                                <a onClick={() => this.updateDocumentDossierState(2)} className="navi-link py-4">
                                <span className="navi-icon mr-5 text-center">
                                    <span className="flaticon-stopwatch text-primary icon-md"></span>
                                </span> 
                                <span className="navi-text text-secondary">
                                    {lang.get('messages.suspender_recurrencia')}
                                </span>
                                <span className="navi-icon pull-right">
                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                    </button>
                                </span>
                                </a>
                            </li>
                            )}

{(
                            this.props.permissions?.dossiers_actions?.includes('all') ||
                            this.props.permissions?.dossiers_actions?.includes('start_recurrence')
                            ) && this.props.frequency === 'yearly' && (
                                <li className="navi-item">
                                <a onClick={  () => this.updateDocumentDossierState(1) } class="navi-link py-4">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon-time text-primary icon-md"></span>
                                    </span>
                                    <span className="navi-text text-secondary">{lang.get('messages.reactivar_recurrencia')} {this.props.document.automatic_frequency_generator} </span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            )}  
                        </ul>
                    </div>
                </div>

            </div>
        );
    }
} 
export default ApprovedDocumentsActions;

if (document.getElementById('ApprovedDocumentsActions')) {
    ReactDOM.render(<ApprovedDocumentsActions />, document.getElementById('ApprovedDocumentsActions'));
}
